import { all, call, put, takeLatest } from 'redux-saga/effects';
import { DatacenterApi } from 'vrlcm-gui-api';
import { ExtendedVCenter } from 'vrlcm-gui-types';
import {
  InitializeStepBinaryMapping,
  initializeStepBinaryMappingFailed,
  initializeStepBinaryMappingSuccess
} from '../../../actions/workflows/steps/BinaryMapping';
import * as Constants from '../../../constants/action-constants';

function* initializeStepBinaryMapping(action: InitializeStepBinaryMapping) {
  try {
    const { dataCenterVmid, vCenterName } = action.payload;
    const vCenter: ExtendedVCenter = yield call(
      DatacenterApi.getVCenter,
      dataCenterVmid,
      vCenterName
    );
    yield put(initializeStepBinaryMappingSuccess(vCenter));
  } catch (e) {
    yield put(initializeStepBinaryMappingFailed());
  }
}

function* watchForBinaryMapping() {
  yield takeLatest(
    Constants.INITIALIZE_STEP_BINARY_MAPPING,
    initializeStepBinaryMapping
  );
}

export default function* binaryMappingSaga() {
  yield all([watchForBinaryMapping()]);
}
